import { render, staticRenderFns } from "./mainPageContent.vue?vue&type=template&id=547dff9c&scoped=true&"
import script from "./mainPageContent.vue?vue&type=script&lang=js&"
export * from "./mainPageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547dff9c",
  null
  
)

export default component.exports